export default __webpack_public_path__ + "static/media/download_EDO project ‘consumindermaart’_doelenlijst.ffc4f8fb.pdf";